/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './data-export-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {DataExportApiService, DataExportModel} from './data-export-api.service';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-data-export-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataExportListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.data-exports.data-export';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type', label: 'exportType'},
    {param: 'source', label: 'fieldsSource'},
    {param: 'data', label: 'dataForExport'},
    {param: 'format'},
    {param: 'schedule'},
    {param: 'compression'},
    {param: '', label: 'fields', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<DataExportModel>(
    inject(DataExportApiService),
    {listId: 'fullDataExportList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  @Input()
  set listConfig(value: Record<string, any>) {
    this.list.additionalParams.set({...value});
  }

  ngOnInit(): void {
    this.list.load();
  }

  shouldShowSimpleDash(item: any): boolean {
    return item?.type === 'PLATFORM_161';
  }

  shouldHideDataSpecificValues(item: any): boolean {
    return this.shouldShowSimpleDash(item) || item?.source === 'RAW_LOG' || item?.source === 'STATS';
  }
}
